/**
 * Platform detection - determines if the app is running inside Electron (desktop)
 * or a standard browser (web). All desktop-specific branching should go through
 * these helpers rather than checking `window.ledgerDesktop` directly.
 */

export type DesktopPlatform = 'win32' | 'darwin'

export interface DesktopCapabilities {
  secureStorage: boolean
  sqlite: boolean
  nativeNotifications: boolean
  deepLinks: boolean
  framelessWindow: boolean
}

export function isDesktop(): boolean {
  return typeof window !== 'undefined' && 'ledgerDesktop' in window
}

export function getDesktopPlatform(): DesktopPlatform | null {
  if (!isDesktop()) return null
  return window.ledgerDesktop.platform
}

export function getDesktopCapabilities(): DesktopCapabilities | null {
  if (!isDesktop()) return null
  return window.ledgerDesktop.getCapabilities()
}

export function getUiVersion(): string | null {
  if (!isDesktop()) return null
  return window.ledgerDesktop.uiVersion
}

export function getShellVersion(): string | null {
  if (!isDesktop()) return null
  return window.ledgerDesktop.shellVersion
}

export function getChannel(): string | null {
  if (!isDesktop()) return null
  return window.ledgerDesktop.channel
}
